module.exports = __webpack_public_path__ + "img/ab-page2-img6.dae1efa0.png";